import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, MessageCapabilityExecutionsResponseDataSchema } from "schema"
import z from "zod"

type Response = DataResponse<z.infer<typeof MessageCapabilityExecutionsResponseDataSchema>>

export const conversationMessageCapabilityExecutionsQuery = (
  messageId: string,
  includeRaw = false,
) => {
  return queryOptions({
    queryKey: ["conversations", "messageCapabilityExecutions", { messageId, includeRaw }],
    placeholderData: undefined,
    queryFn: async () => {
      const response = await axios.get<Response>(`/messages/${messageId}/capabilityExecutions`, {
        params: { includeRaw },
      })
      return response.data.data
    },
  })
}
